import Vue from 'vue'
import Router from 'vue-router'
// import home from './home'
import mine from './mine'
import square from './square'
import room from './room'
import library from './library'
import proList from './proList'
import school from './school'
import notes from './notes'
import login from './login'
import statistics from './statistics'
import construction from './construction'
import learn from './learn'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  // home,
  notes,
  square,
  room,
  library,
  statistics,
  mine,
  proList,
  school,
  login,
  construction,
  learn
]
export default new Router({
  mode: 'history',
  routes
})
